const BaseList = require("app/components/lists/List");
const SingleItem = require("app/components/products/SingleProduct");

class ProductList extends BaseList {

	get className() {
		return "product-list";
	}

	renderItem(item, key) {
		return <SingleItem key={item.id} {...item}/>
	}

}

module.exports = ProductList;
